import { useOktaAuth } from '@okta/okta-react'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { availableRoutes } from '../../src/available-routes'

export function useMainNavigation() {
  const { oktaAuth } = useOktaAuth()
  const [isSidebarOpen, setSidebarOpen] = useState(true)

  const logout = async () => {
    oktaAuth.tokenManager.clear()
    await oktaAuth.signOut()
  }

  const toggleSidebar = () => {
    setSidebarOpen((wasOpen) => !wasOpen)
  }

  const { data: user } = useQuery({
    queryKey: ['authenticatedUser'],
    queryFn: async () => {
      const user = await oktaAuth.getUser()
      const initials = `${user.given_name?.[0]}${user.family_name?.[0]}`
      return {
        ...user,
        initials
      }
    },
    placeholderData: {
      initials: '',
      sub: '',
      auth_time: undefined,
      aud: undefined,
      email: undefined,
      email_verified: undefined,
      exp: undefined,
      family_name: undefined,
      given_name: undefined,
      iat: undefined,
      iss: undefined,
      jti: undefined,
      locale: undefined,
      name: undefined,
      preferred_username: undefined,
      zoneinfo: undefined,
      acr: undefined,
      },
    }
  )
  return {
    logout,
    routes: availableRoutes(),
    user,
    isSidebarOpen,
    toggleSidebar,
  }
}
